// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { AdoArtifactsCard } from './AdoArtifactsCard';

const adoArtifactsCard = EntityCardBlueprint.make({
  name: 'ado-artifacts',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { AdoArtifactsCard } = await import('./AdoArtifactsCard');
      return <AdoArtifactsCard />;
    },
  },
});

export const adoArtifactsCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [adoArtifactsCard],
});
